import { useEffect, useState } from "react";

// False during the server render (prerender) and during the client's hydration
// render, true right after the component mounts in the browser. Gating browser only
// UI on this keeps the client's first render identical to the prerendered markup, so
// hydration never sees a mismatch.
export const useIsMounted = (): boolean => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
};
